import React from 'react';
import { Box, CustomMenu, Modal } from '@agilize/components-core';
import { logout } from '@services/auth/Auth';
import { ModalMenuProps } from './ModalMenu.types';
import { ApplicationTitle, StyledButton } from './ModalMenu.styles';

const ModalMenu = (props: ModalMenuProps) => {
  const { isOpen, onClose, formattedCompanies, formattedSelectedCompany, handleChangeCompany } = props;
  const goToProfile = () => {
    window.location.href = `${process.env.LOGIN_APP}/realms/${process.env.REALM}/account/`;
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="small" title="O que deseja fazer?">
      <div>
        <ApplicationTitle>Mudar de sistema</ApplicationTitle>
        <agz-menu-apps current="rh" list="true" />
      </div>
      {formattedCompanies.length > 1 && (
        <Box pt={32}>
          <ApplicationTitle>Mudar de empresa</ApplicationTitle>
          <Box pt="8px">
            <CustomMenu items={formattedCompanies} selectedItem={formattedSelectedCompany} onClick={handleChangeCompany} />
          </Box>
        </Box>
      )}
      <Box pt={32}>
        <StyledButton variant="text" onClick={goToProfile}>
          Minha conta
        </StyledButton>
        <StyledButton color="remove-light" type="button" onClick={() => logout()}>
          Sair da conta
        </StyledButton>
      </Box>
    </Modal>
  );
};

export default ModalMenu;
